import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Box } from "@mui/system";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CssTextField from "../../components/overrides/longSearchField";
import { getRosterWatcher } from "../../redux/actionCreators/admin/rosterManagement";
import { getDropDownWatcher } from "../../redux/actionCreators/admin/employeeManagement";
import { updateVendorId } from "../../redux/actionCreators/user/home";
import { DROPDOWN_PLACEHOLDER_ID } from "../../utils/constants";

// Picks the vendor the user orders from. Asked for right after login (the
// dialog can't be dismissed until a vendor is chosen) and changeable from the
// navbar afterwards. Menus, cart and orders all follow the chosen vendor; the
// roster decides which cafeteria that vendor serves on a given day.
const Vendor = () => {
  const dispatch = useDispatch();

  const {
    EmployeeReducers: { vendorName },
    UserHomeReducers: { vendorId },
  } = useSelector((state) => state);

  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState(null);
  const tempinitform = useRef();

  // Every active vendor, as in 3D Cafe
  const options = (vendorName || [])
    .filter((v) => +v.id !== DROPDOWN_PLACEHOLDER_ID)
    .map((v) => ({ id: +v.id, name: v.name }));
  const selected = options.find((v) => v.id === +vendorId) || null;
  const ready = options.length > 0;

  const choose = (id) => {
    dispatch(updateVendorId(id));
    try {
      if (id) sessionStorage.setItem('vendorId', id);
      else sessionStorage.removeItem('vendorId');
    } catch (e) { }
  };

  useEffect(() => {
    dispatch(getDropDownWatcher());
    dispatch(getRosterWatcher({ ACTION: "SELECT" }));
  }, [dispatch]);

  // A vendor remembered from before that has since been removed has to be picked again
  const initform = () => {
    if (vendorId && ready && !selected) choose(null);
  };

  tempinitform.current = initform;

  useEffect(() => {
    tempinitform.current();
  }, [vendorName, vendorId]);

  const mustPick = ready && !selected;

  const handleOpen = () => {
    setPicked(selected);
    setOpen(true);
  };

  const handleSubmit = () => {
    if (!picked) return;
    choose(picked.id);
    setOpen(false);
  };

  return (
    <>
      <Button
        variant='outlined'
        sx={{ height: 40, minWidth: 173, justifyContent: 'space-between' }}
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleOpen}
        disabled={!ready}
      >
        <Typography color="common.black" variant="t14_400" noWrap>
          {selected ? selected.name : 'Select Vendor'}
        </Typography>
      </Button>

      <Dialog
        open={mustPick || open}
        onClose={() => !mustPick && setOpen(false)}
        fullWidth
        maxWidth='sm'
      >
        <DialogTitle>
          <Typography variant='t20_600'>Please Choose Your Vendor</Typography>
        </DialogTitle>
        <DialogContent>
          <Box pt='8px' pb='15px'>
            <Typography variant="t14_600">Vendor</Typography>
          </Box>
          <Autocomplete
            id="vendor-picker"
            fullWidth
            autoHighlight
            options={options}
            value={picked}
            onChange={(e, value) => setPicked(value)}
            getOptionLabel={(option) => option.name || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <CssTextField
                {...params}
                placeholder="Vendor"
                sx={{ '& .MuiOutlinedInput-root': { height: 50 } }}
              />
            )}
          />
        </DialogContent>
        <DialogActions sx={{ p: '0 24px 20px' }}>
          {!mustPick &&
            <Button variant='outlined' sx={{ width: 100, height: 36 }} onClick={() => setOpen(false)}>
              <Typography color="common.black" variant="t14_400">Cancel</Typography>
            </Button>
          }
          <Button variant='contained' sx={{ width: 100, height: 36 }} onClick={handleSubmit} disabled={!picked}>
            <Typography color="common.white" variant="t14_400">Submit</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Vendor;
